const royerReviewsSection = /** @type {HTMLElement}*/ (document.getElementById("royer-reviews-section"));
const royerHeaderScoreWrapper = /** @type {HTMLElement}*/ (document.querySelector(".reviews-left-section"));
const royerNoReviewWrapper = /** @type {HTMLElement}*/ (document.querySelector(".royer-reviews-no-review-wrapper"));
const royerReviewOrderingWrapper = /** @type {HTMLElement}*/ (document.querySelector(".review-entry-sort"));
const royerReviewOrderingSelect = /** @type {HTMLSelectElement}*/ (document.getElementById("royer-reviews-orderering-select"));
const reviewEntriesWrapper = /** @type {HTMLElement}*/ (document.querySelector(".review-entries-wrapper"));
const royerReviewTemplate = /** @type {HTMLElement}*/ (document.getElementById("review-entry-wrapper-template"));
const royerReviewsErrorToast = /** @type {HTMLElement}*/ (document.getElementById("royer-reviews-error-toast"));
const royerReviewplaceholders = /** @type {HTMLElement[]}*/ (Array.from(document.getElementsByClassName("review-placeholder")));
const royerReviewsLoadMoreWrapper = /** @type {HTMLElement}*/ (document.querySelector(".royer-reviews-load-more-wrapper"));
const royerReviewsLoadMoreBtn = /** @type {HTMLButtonElement}*/ (document.querySelector(".royer-reviews-load-more-btn"));
const royerReviewsLoadMoreBtnText = /** @type {HTMLElement}*/ (document.querySelector(".royer-reviews-load-more-btn-text"));
const royerReviewsLoadMoreBtnSpinner = /** @type {HTMLElement}*/ (document.querySelector(".royer-reviews-load-more-btn-spinner"));

/** @type {Bootstrap.Toast} */
let royerReviewsErrorToastBootstrap;

const reviewListPageSize = 10;
let reviewListCrtPage = 0;

const reviewsWebReviewApi = getDivZeroWebPublicApi(DivZeroWebPublicApi.WebArtReviewApi, false);

/**
 * 
 * @param {IntersectionObserverEntry[]} entries 
 * @param {IntersectionObserver} observer 
 */
const reviewListIntersectionObserverCallback = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      reviewListIntersectionObserver.unobserve(entry.target);
      LoadReviews();
    }
  });
};

const reviewListIntersectionObserver = new IntersectionObserver(
  reviewListIntersectionObserverCallback
);

//Only do all the loading review logic if there is at least one review
if (!royerNoReviewWrapper) {
  reviewListIntersectionObserver.observe(royerReviewsSection);

  document.addEventListener("DOMContentLoaded", (event) => {
    royerReviewsErrorToastBootstrap = bootstrap.Toast.getOrCreateInstance(
      royerReviewsErrorToast,
      { delay: 5000 }
    );
  });

  royerReviewOrderingSelect.addEventListener("change", () => {
    reviewListCrtPage = 0;
    LoadReviews();
  });

  royerReviewsLoadMoreBtn.addEventListener("click", () => LoadReviews(reviewListPageSize, reviewListCrtPage, false));
}

async function LoadReviews(
  pageSize = reviewListPageSize,
  pageNb = reviewListCrtPage,
  firstLoad = true
) {
  if (firstLoad) {
    const realReviews = Array.from(
      document.querySelectorAll(
        ".review-entry-wrapper:not(.review-placeholder,#review-entry-wrapper-template)"
      )
    );
    loadingAnimationReviews(true);
    realReviews.forEach((review) => review.remove());
  }
  else {
    royerReviewsLoadMoreBtn.disabled = true;
    royerReviewsLoadMoreBtnText.classList.add("invisible");
    royerReviewsLoadMoreBtnSpinner.classList.remove("d-none");
  }

  const orderBySelectedOptionEl = royerReviewOrderingSelect.selectedOptions.item(0);

  try {
    var response = await reviewsWebReviewApi.webArtReviewGetWebArtReviews({
      displayLang: locale,
      pageNb: pageNb,
      pageSize: pageSize,
      divZeroWebApiDomainNswagApiModelsDivZeroWebApiModelsWebArtReviewFilters: {
        orderBy: [{
          value: /** @type {DivZeroWebPublicModels.WebArtReviewOrderByEnum} */ (parseInt(orderBySelectedOptionEl?.value ?? "0")),
          direction: /** @type {DivZeroWebPublicModels.OrderByDirection} */ (parseInt(orderBySelectedOptionEl?.dataset.direction ?? "0"))
        }],
        includeColorVariantReviewsForArtIdFilter: true,
        includeEmptyBodyReviews: false,
        artIdWL: [product.dbId],
        hidden: false,
        curatedWL: [1]
      }
    });

    if (response.hasNextPage) royerReviewsLoadMoreWrapper.classList.remove("d-none");
    else royerReviewsLoadMoreWrapper.classList.add("d-none");

    response.items?.forEach((review) => {
      const newReviewEl = /** @type {HTMLElement}*/ (royerReviewTemplate.cloneNode(true));
      //Wiping the id of the template element
      newReviewEl.id = "";
      reviewEntriesWrapper.appendChild(newReviewEl);
      //Making sure that any script inside the copied element is ran (script is ran if you directly append it instead of it being a child of the element being appended)
      Array.from(newReviewEl.querySelectorAll("script")).forEach(script => {
        // Create a new script element
        const newScript = document.createElement("script");
        newScript.textContent = script.textContent;
        // Replace the old script with the new one
        script.parentNode?.replaceChild(newScript, script);
      });
      //Filling stars
      const roundedNearestHalfInt = Math.round((review.rating ?? 0) * 2) / 2;
      const starSvgs = Array.from(newReviewEl.querySelectorAll(".royer-reviews-star-wrapper svg.star-svg"));
      for (let i = 0; i <= roundedNearestHalfInt - 1; i++) {
        starSvgs[i].classList.add("full");
      }
      if (roundedNearestHalfInt % 1 != 0) starSvgs[Math.floor(roundedNearestHalfInt)].classList.add("half-full")
      //Filling country
      if (review.countryCode != null) {
        const countryEl = /** @type {HTMLElement}*/ (newReviewEl.querySelector(".royer-reviews-country"));
        countryEl.innerText = countryTranslation[review.countryCode];
      }
      //Filling region
      if (review.regionCode != null) {
        const regionEl = /** @type {HTMLElement} */ (newReviewEl.querySelector(".royer-reviews-region"));
        regionEl.innerText = ", " + review.regionCode;
      }
      //Filling date
      const creationDate = review.createdOn ?? new Date();
      const yyyy = creationDate.getFullYear();
      const mmNumber = creationDate.getMonth() + 1;
      const ddNumber = creationDate.getDate();
      let mmString = mmNumber < 10 ? '0' + mmNumber : mmNumber.toString();
      let ddString = ddNumber < 10 ? '0' + ddNumber : ddNumber.toString();

      const dateEl = /** @type {HTMLElement} */(newReviewEl.querySelector(".royer-reviews-date"));
      dateEl.innerText = ddString + '/' + mmString + '/' + yyyy;

      //Filling reviewer name
      const nameEl = /** @type {HTMLElement}*/ (newReviewEl.querySelector(".review-entry-reviewer-name"));
      nameEl.innerText = (review.firstName ?? "") + (review.lastName ? " " + review.lastName : "");
      //Showing or hiding verified customer tag
      const verifiedValues = [
        //Confirmed buyer
        2,
        //Buyer
        4,
        //Verified Purchase
        5,
        //Admin
        7,
      ];
      const verifiedWrapper = /** @type {HTMLElement}*/ (newReviewEl.querySelector(".review-entry-verified"));
      if (review.verified && verifiedValues.includes(review.verified))
        verifiedWrapper.classList.remove("d-none");
      else verifiedWrapper.classList.add("d-none");
      //Filling model link
      const modelLink = /** @type {HTMLLinkElement}*/ (newReviewEl.querySelector(".review-entry-model-link"));
      modelLink.innerText = review.articleReference ?? "";


      if (review.articleReference != product.title) {
        let url = product.otherColorProducts.find((product) => product.title == review.articleReference)?.url;
        if (url) modelLink.href = url;
        else {
          modelLink.classList.add("pe-none");
          modelLink.classList.add("text-decoration-none");
        }
      }

      let title = null;
      let body = null;
      let originalTitle = null;
      let originalBody = null;

      const siteLocale = Shopify.locale.toUpperCase();
      title = review.title;
      body = review.body;

      if (review.lang != locale) {
        originalTitle = review.originalLanguageTitle;
        originalBody = review.originalLanguageBody;
      }

      //Filling review title
      const titleEl = /** @type {HTMLElement} */ (newReviewEl.querySelector(".review-entry-title"));
      titleEl.innerText = title ?? "";
      //Filling review body
      const bodyEl = /** @type {HTMLElement} */ (newReviewEl.querySelector(".review-entry-body"));
      bodyEl.innerText = body ?? "";
      //Hide original language section if already in original language
      const originalLanguageWrapper =  /** @type {HTMLElement}*/ (newReviewEl.querySelector(".review-original-language"));
      if (originalTitle || originalBody) {
        originalLanguageWrapper.classList.remove("d-none");
        const ogTitleEl = /** @type {HTMLElement} */ (newReviewEl.querySelector(".review-entry-original-title"));
        ogTitleEl.innerText = originalTitle ?? "";
        const ogBodyEl = /** @type {HTMLElement} */ (newReviewEl.querySelector(".review-entry-original-body"));
        ogBodyEl.innerText = originalBody ?? "";
      }
      else originalLanguageWrapper.classList.add("d-none");
    });
    //Remove loading animations
    loadingAnimationReviews(false);
    royerReviewsLoadMoreBtn.disabled = false;
    royerReviewsLoadMoreBtnText.classList.remove("invisible");
    royerReviewsLoadMoreBtnSpinner.classList.add("d-none");

    //Increment current page
    reviewListCrtPage++;
  }
  catch (error) {
    //Hide the loader again
    writeAReviewModalLoader?.classList.remove("show");
    royerReviewsErrorToastBootstrap.show();
    console.log(error);
  }

  writeAReviewModalLoader?.classList.remove("show");
}

/**
 * If no showLoading parameter is passed it will act as a toggle
 * @param {Boolean} showLoading 
 */
function loadingAnimationReviews(showLoading) {
  const realReviews = Array.from(document.querySelectorAll(".review-entry-wrapper:not(.review-placeholder,#review-entry-wrapper-template)"));
  realReviews.forEach((review) => {
    if (showLoading == undefined) review.classList.toggle("d-none");
    else if (showLoading) review.classList.add("d-none");
    else review.classList.remove("d-none");
  });
  if (showLoading == undefined)
    royerReviewplaceholders.forEach((placeholder) =>
      placeholder.classList.toggle("d-none")
    );
  else if (showLoading)
    royerReviewplaceholders.forEach((placeholder) =>
      placeholder.classList.remove("d-none")
    );
  else
    royerReviewplaceholders.forEach((placeholder) =>
      placeholder.classList.add("d-none")
    );
}
